class EnumUtil {
    static getItemBasedOnValue(items, searchedItem) {
        const foundedItem = Object.entries(items).find(([_, value]) => value === searchedItem);
        if (foundedItem) {
            return foundedItem[0];
        }
        return undefined;
    }
}
export default EnumUtil;
